import { SectionCard } from "./SectionCard";
import { fmtUSD } from "@/lib/api";
import { FileText } from "lucide-react";

export default function PagaresEmitidos({ data }) {
  if (!data) return null;
  return (
    <SectionCard
      id="pagares-emitidos"
      testid="section-pagares-emitidos"
      num="3"
      title="Resumen de Pagarés Emitidos en el Mes"
      description="Agrupación por cliente de los pagarés pendientes de firma emitidos en el mes en curso de análisis (mes de la fecha de corte, Septiembre 2026). Los pagarés de meses anteriores figuran en la Sección 4."
    >
      <div className="overflow-x-auto rounded-lg border border-slate-100">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wide">
              <th className="text-left px-4 py-3 font-semibold">Cliente</th>
              <th className="text-center px-4 py-3 font-semibold">Cantidad Documentos</th>
              <th className="text-right px-4 py-3 font-semibold">Valor Total</th>
            </tr>
          </thead>
          <tbody>
            {data.items.map((r, i) => (
              <tr key={i} className="border-t border-slate-100 hover:bg-emerald-50/40">
                <td className="px-4 py-2.5 font-medium text-slate-800 flex items-center gap-2">
                  <FileText className="h-4 w-4 text-emerald-600" /> {r.cliente}
                </td>
                <td className="px-4 py-2.5 text-center font-mono text-slate-700">{r.cantidad}</td>
                <td className="px-4 py-2.5 text-right font-mono font-semibold text-emerald-700">{fmtUSD(r.valor_total_usd)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="bg-emerald-50 border-t-2 border-emerald-200 font-semibold">
              <td className="px-4 py-3 text-emerald-900 uppercase text-xs tracking-wide">Total</td>
              <td className="px-4 py-3 text-center font-mono text-emerald-900">{data.total_documentos} docs</td>
              <td className="px-4 py-3 text-right font-mono text-emerald-900">{fmtUSD(data.total_valor_usd)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </SectionCard>
  );
}
